export let culture = "en-GB";
export const setCulture = (new_culture: string) => {
    culture = new_culture;
};
